"use client";

import { useLocale } from "@/context/LocaleContext";
import { I18nData } from "@/types/i18n";
import Footer from "./footer";
import { Branding } from "@/types/branding";

interface FooterWrapperProps {
  i18nData?: I18nData;
  branding?: Branding;
}

export default function FooterWrapper({
  i18nData,
  branding,
}: FooterWrapperProps) {
  const { locale } = useLocale();
  return <Footer i18nData={i18nData} locale={locale} branding={branding} />;
}
